"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _Embed = _interopRequireDefault(require("./Embed"));
exports.default = _Embed.default;